import script from "./HelpRequestPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpRequestPopup.vue?vue&type=script&setup=true&lang=ts"

import "./HelpRequestPopup.vue?vue&type=style&index=0&id=250b38a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-250b38a0"]])

export default __exports__